interface OrganizationEndpoints {
  LIST: string;
  CREATE: string;
  UPDATE: (id: string) => string;
  DELETE: (id: string) => string;
  RESTORE: (id: string) => string;
  ROLE: (id: string) => string;
  PERMS: (id: string) => string;
  PREFERENCES: (id: string) => string;
  USERS: (id: string) => string;
  MEMBERS: (id: string) => string;
  CURRUSER: (id: string) => string;
  INVITES: (id: string) => string;
  DEPARTMENTS: (id: string) => string;
  PROJECTS: {
    CREATE: (orgId: string) => string;
    LIST: (orgId: string, showArchived?: boolean) => string;
    DETAIL: (orgId: string, projectId: string) => string;
    COPY_TO_FISCAL_YEAR: (orgId: string, projectId: string) => string;
    PM_PREFERENCE: (orgId: string, projectId: string) => string;
    PENCILS_DOWN: (orgId: string, projectId: string) => string;
    BO_APPROVAL: (orgId: string, projectId: string) => string;
    RESTORE: (orgId: string, projectId: string) => string;
    SUBPROJECTS: {
      CREATE: (orgId: string, projectId: string) => string;
      LIST: (orgId: string, projectId: string) => string;
    };
    COST_ESTIMATE: (orgId: string, projectId: string) => string;
  };
  SUBPROJECTS: {
    CREATE: (orgId: string) => string;
    LIST: (orgId: string) => string;
    DETAIL: (orgId: string, subprojectId: string) => string;
    DUPLICATE: (orgId: string, subprojectId: string) => string;
    PENCILS_DOWN: (orgId: string, subprojectId: string) => string;
  };
}

export const organizationEndpoints: OrganizationEndpoints = {
  LIST: '/api/organizations/',
  CREATE: '/api/organizations/',
  UPDATE: (id: string) => `/api/organizations/${id}/`,
  DELETE: (id: string) => `/api/organizations/${id}/`,
  RESTORE: (id: string) => `/api/organizations/${id}/restore/`,
  ROLE: (id: string) => `/api/organizations/${id}/role/`,
  PERMS: (id: string) => `/api/organizations/${id}/perms/`,
  PREFERENCES: (id: string) => `/api/organizations/${id}/preferences/`,
  USERS: (id: string) => `/api/organizations/${id}/users/`,
  MEMBERS: (id: string) => `/api/organizations/${id}/members/`,
  CURRUSER: (id: string) => `/api/organizations/${id}/current-user/`,
  INVITES: (id: string) => `/api/organizations/${id}/invites/`,
  DEPARTMENTS: (id: string) => `/api/organizations/${id}/departments/`,
  PROJECTS: {
    CREATE: (orgId: string) => `/api/organizations/${orgId}/projects/`,
    LIST: (orgId: string, showArchived?: boolean) =>
      `/api/organizations/${orgId}/projects/${showArchived ? '?showArchived' : ''}`,
    DETAIL: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/`,
    COPY_TO_FISCAL_YEAR: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/copy-to-fiscal-year/`,
    PM_PREFERENCE: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/pm-preference/`,
    PENCILS_DOWN: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/pencils-down/`,
    BO_APPROVAL: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/bo-approval/`,
    RESTORE: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/restore/`,
    SUBPROJECTS: {
      CREATE: (orgId: string, projectId: string) =>
        `/api/organizations/${orgId}/projects/${projectId}/subprojects/`,
      LIST: (orgId: string, projectId: string) =>
        `/api/organizations/${orgId}/projects/${projectId}/subprojects/`,
    },
    COST_ESTIMATE: (orgId: string, projectId: string) =>
      `/api/organizations/${orgId}/projects/${projectId}/cost-estimate/`,
  },
  SUBPROJECTS: {
    CREATE: (orgId: string) =>
      `/api/organizations/${orgId}/subprojects/building/`,
    LIST: (orgId: string) => `/api/organizations/${orgId}/subprojects/`,
    DETAIL: (orgId: string, subprojectId: string) =>
      `/api/organizations/${orgId}/subprojects/building/${subprojectId}/`,
    DUPLICATE: (orgId: string, subprojectId: string) =>
      `/api/organizations/${orgId}/subprojects/building/${subprojectId}/duplicate/`,
    PENCILS_DOWN: (orgId: string, subprojectId: string) =>
      `/api/organizations/${orgId}/subprojects/building/${subprojectId}/pencils-down/`,
  },
};
